export default "__VITE_ASSET__63800a2c__"